import { createFileRoute, redirect } from "@tanstack/react-router";
import { rememberScope } from "../../app/scope";
import { legacyReservedSearch, reservedPath } from "../../features/marketplace/navigation";

export const Route = createFileRoute("/_authed/marketplace/$marketOrg")({
  validateSearch: legacyReservedSearch,
  beforeLoad: async ({ context, params, search }) => {
    const orgs = await context.queryClient.fetchQuery({ queryKey: ["user", "orgs", context.session.user.id], queryFn: context.api.organizations });
    const org = orgs.find((o) => o.metadata.name === params.marketOrg);
    if (org) rememberScope(context.session.user.id, org.metadata.name);
    throw redirect({ href: search.request ? "/reserved-compute/request" : reservedPath(search.view), replace: true });
  },
});
